import ApiService from "../apiservice";

class EmpresasFalidasService extends ApiService {

    constructor() {
        super('/api/empresas');
    }

    listarEmpresasFalidas(filtros) {
        return this.post('/buscarEmpresasFalidas', filtros)
    }

    gerarRelatorioEmpresasFalidas(filtros) {
        return this.post('/relatorioEmpresasFalidas', filtros)
    }

  
}

export default EmpresasFalidasService;